import Listener from './Listener'

/**
 * Класс наблюдает за прохождение точки {@link point} на странице при скроле по оси Y
 * когда мы находимся ниже точки срабатывает коллбек onScrollBelow
 * когда мы находимся выше точки срабатывает коллбек onScrollAbove
 *
 * TODO переписать так чтобы событие не было шумным т.е. функции вызывались по одному разу после прохождения точки
 */
export default class ScrollYPointWatcher {

   constructor(point, onScrollBelow, onScrollAbove) {
      if (!parseInt(point) || parseInt(point) < 0) {
         console.error('ScrollYPointWatcher: incorrect point')
         return
      }
      this.point = parseInt(point)
      Listener.onScroll(() => {
         if (window.pageYOffset > this.point) {
            if (onScrollBelow) {
               onScrollBelow()
            }
         } else {
            if (onScrollAbove) {
               onScrollAbove()
            }
         }
      })
   }
}